import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    frecuencia: [],
  },

  getters: {
    getFrecuencia: (state) => state.frecuencia,
  },

  mutations: {
    SET_FRECUENCIA(state, frecuencia) {
      state.frecuencia = frecuencia;
    },
  },

  actions: {
    async fetchFrecuencia({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catFrecuencia')
        .then((response) => {
          commit('SET_FRECUENCIA', response.data.data);
        });
    },
  },
};
